// One month at a time, with an arrow either side. Shared by the dashboard's period
// control and the settlement screen's monthly collection card, which is why it lives
// here rather than in either page's folder.
//
// RTL: the arrow for the PREVIOUS month points right, matching the reading direction,
// and DOM order puts it first — i.e. rightmost — on screen. That convention is worth
// having in one place: derived independently on a second screen it comes out mirrored
// about half the time, and a back arrow that goes forward is not a small bug.
//
// BOTH DIRECTIONS ARE OPEN-ENDED, and that is a decision rather than an omission. A
// month with nothing in it shows zeros, which is a perfectly good answer — a quiet month
// is information. Clamping the arrows to months that happen to hold data would hide
// exactly that, and on the dashboard a future month isn't necessarily empty anyway,
// since an expense can be dated ahead.
//
// The aria labels are passed in rather than read from i18n here: the two callers name
// this control differently in their own sections, and a shared component that reaches
// into one caller's strings is how a section ends up owning a key it doesn't use.
import Button from './Button';
import { formatMonthLong } from './DateText';
import { addMonths } from '../utils/dates';

export default function MonthStepper({ month, onChange, prevLabel, nextLabel }) {
  const goto = (n) => () => onChange(addMonths(month, n));
  return (
    <>
      <Button small variant="subtle" aria-label={prevLabel} onClick={goto(-1)}>▶</Button>
      <strong className="period-label">{formatMonthLong(month)}</strong>
      <Button small variant="subtle" aria-label={nextLabel} onClick={goto(1)}>◀</Button>
    </>
  );
}
